import axios from "axios";
import { hostServer } from "./consts/host";
import { message } from "antd";
import { history } from "../routers/AppRouter";
import { changeFetchInProg } from "./fetchInProgress";
import * as R from "ramda";
import format from "date-fns/format";
import { changeLoadingInProg } from "./loadingInProgress";

// const redirectablePaths = [
//   "/monitor",
//   "/monitor/",
//   "/impersonate",
//   "/impersonate/",
//   "/symlink",
//   "/symlink/"
// ];

// ADD_CHECK
export const addCheck = (check) => ({
  type: "ADD_CHECK",
  check,
});

export const startAddCheck = (monitor) => {
  return async (dispatch, getState) => {
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };

    const data = { ...monitor };

    try {
      const res = await axios.post(`${hostServer}/api/v1/monitors/`, data, header);
      const token = `${res.data.id}/metric`;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "service",
        service_name: "Monitor",
      });

      const result = await axios.get(`${hostServer}/api/v1/monitors/${token}`, header);
      const isHttp = res.data.protocol_type === "HTTP(S)";
      const target = isHttp ? res.data.url : res.data.host;
      const name = res.data.alias ? `${res.data.protocol_type}:${res.data.alias}` : target;
      dispatch(
        addCheck({
          ...res.data,
          data: result.data,
          target,
          name,
        })
      );
      const refreshTime = 30000;
      setTimeout(() => {
        dispatch(startRefresh(res.data.id, true));
      }, refreshTime);
      history.push(`/monitor/${getState().checks[0].id}`);
      message.success("Your monitor created!");
    } catch (e) {
      message.warning(e.response.data.error);
    }
  };
};

// REMOVE_EXPENSE
export const removeCheck = ({ id } = {}) => ({
  type: "REMOVE_CHECK",
  id,
});

export const startRemoveCheck = ({ id } = {}) => {
  return async (dispatch, getState) => {
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    try {
      await axios.delete(`${hostServer}/api/v1/monitors/${id}/`, header);
      dispatch(removeCheck({ id }));
      if (getState().checks.length > 0) {
        history.push(`/monitor/${getState().checks[0].id}`);
      } else {
        history.push("/");
      }
      message.success("Monitor removed!");
    } catch (e) {
      message.warning("Something went wrong please try again later!");
    }
    dispatch(changeFetchInProg(false));
  };
};

// EDIT_EXPENSE
export const editCheck = (id, updates) => ({
  type: "EDIT_CHECK",
  id,
  updates,
});

export const startEditCheck = (updates) => {
  return async (dispatch, getState) => {
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const monitors = R.clone(getState().checks);
    const monitor = monitors.filter((el) => {
      return updates.id === el.id;
    })[0];
    delete monitor.data;
    const data = {
      ...monitor,
      ...updates,
    };
    try {
      const res = await axios.put(`${hostServer}/api/v1/monitors/${updates.id}/`, data, header);
      const token = `${res.data.id}/metric`;
      const result = await axios.get(`${hostServer}/api/v1/monitors/${token}`, header);
      dispatch(
        editCheck(res.data.id, {
          ...res.data,
          data: result.data,
        })
      );
      message.success("Your monitor edited successfully!");
    } catch (e) {
      message.warning(e.response.data.error);
    }
  };
};

export const startSetChecks = () => {
  return async (dispatch, getState) => {
    const json = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    dispatch(changeFetchInProg(true));
    const res = await axios.get(`${hostServer}/api/v1/monitors/`, json);
    const ps = [];
    const monitorsRes = res.data.results;
    monitorsRes.forEach(function (check, i) {
      const token = `${check.id}/metric`;
      const p = axios.get(`${hostServer}/api/v1/monitors/${token}`, json).then((res) => {
        const isHttp = check.protocol_type === "HTTP(S)";
        const target = isHttp ? check.url : check.host;
        const name = check.alias ? `${check.protocol_type}:${check.alias}` : target;
        const status = res.data ? (isHttp ? res.data.last_status_code : res.data.last_status) : null;

        dispatch(
          addCheck({
            ...check,
            data: res.data,
            target,
            name,
            status,
            isHttp,
          })
        );
        if (!res.data) {
          const refreshTime = 30000;
          setTimeout(() => {
            dispatch(startRefresh(check.id, true));
          }, refreshTime);
        }
      });
      ps.push(p);
    });

    try {
      await Promise.all(ps);
      const pathArray = window.location.pathname.split("/");
      const isMobile = window.innerWidth < 850;
      const notEmpty = R.compose(R.not, R.isEmpty);
      const filteredArray = R.filter(notEmpty, pathArray);
      const shouldRedirect = R.isEmpty(filteredArray);
      if (shouldRedirect && !isMobile) {
        const firstMonitorId = getState().checks[0].id;
        history.push(`/monitor/${firstMonitorId}`);
      }
    } catch (e) {
      console.log(e);
    }
    dispatch(changeFetchInProg(false));
    dispatch(changeLoadingInProg(false));
  };
};

export const startSetSymlinkCheck = (token, org) => {
  return async (dispatch) => {
    dispatch(changeFetchInProg(true));
    try {
      const res = await axios.get(
        `${hostServer}/api/v1/monitors/${org ? `${org}/` : ""}${token}/${org ? "metric" : "share_info"}`
      );
      const isHttp = res.data.monitor.protocol_type === "HTTP(S)";
      const target = isHttp ? res.data.monitor.url : res.data.monitor.host;
      const name = res.data.monitor.alias ? `${res.data.monitor.protocol_type}:${res.data.monitor.alias}` : target;
      const status = isHttp ? res.data.metric.last_status_code : res.data.metric.last_status;

      dispatch(
        addCheck({
          ...res.data.monitor,
          data: res.data.metric,
          target,
          name,
          status,
        })
      );
    } catch (e) {
      console.error(e);
    }
    dispatch(changeFetchInProg(false));
  };
};

export const startRefreshAll = () => {
  return async (dispatch, getState) => {
    try {
      const monitors = getState().checks;
      monitors.forEach((monitor) => {
        dispatch(startRefresh(monitor.id, true));
      });
    } catch (e) {}
  };
};

export const startRefresh = (id, isRefresh) => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const json = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    try {
      const res = await axios.get(`${hostServer}/api/v1/monitors/${id}/metric?cache=False`, json);
      const check = R.find((val) => id === R.path(["id"], val), getState().checks);
      const isHttp = check.protocol_type === "HTTP(S)";
      const target = isHttp ? check.url : check.host;
      const name = check.alias ? `${check.protocol_type}:${check.alias}` : target;
      const status = res.data ? (isHttp ? res.data.last_status_code : res.data.last_status) : null;

      dispatch(editCheck(id, { data: res.data, target, name, status, isHttp }));
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};

export const startGetMonitorHistory = (id, date) => {
  return async (dispatch, getState) => {
    const json = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const day = format(new Date(date), "yyyy-MM-d");
    dispatch(changeFetchInProg(true));
    console.log(day);

    const res = await axios.get(`${hostServer}/api/v1/monitors/${id}/metric?day=${day}`, json);

    if (res.data !== null) {
      dispatch(editCheck(id, { data: res.data }));
    }
    dispatch(changeFetchInProg(false));
  };
};

export const updateCheck = (check) => ({
  type: "UPDATE_CHECK",
  check,
});

export const clearChecks = () => ({
  type: "CLEAR_CHECKS",
});
